import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

import { getProtectedRoutes } from '~/config/routes';
import { ACCESS_TOKEN_STORAGE_KEY } from '~/constants';
import localstorage from '~/foundation/storage/localstorage';
import useAuth from '~/store/auth/useAuth';

const token = localstorage.get<string>(ACCESS_TOKEN_STORAGE_KEY);

const protectedRoutes = getProtectedRoutes();

const updatedRoutes = routes.map((route) => {
  const protectedRoute = protectedRoutes[route.path as keyof typeof protectedRoutes];

  if (protectedRoute) {
    return {
      ...route,
      component: protectedRoute.component,
      meta: {
        requiresGroup: protectedRoute.requiresGroup,
        requiresRole: protectedRoute.requiresRole,
      },
    };
  }

  return route;
});

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'active',
  routes: updatedRoutes as RouteRecordRaw[],
});

router.beforeEach(async (to, from, next) => {
  if (!token) {
    return next();
  }

  if (!to.meta.requiresRole && !to.meta.requiresGroup) {
    return next();
  }

  const authQuery = useAuth();

  if (authQuery.isLoading.value) {
    await authQuery.refetch();
  }

  const auth = authQuery.data?.value;

  if (!auth) {
    return next('/unauthorized');
  }

  if (to.meta.requiresRole) {
    const requiredRoles = Array.isArray(to.meta.requiresRole)
      ? to.meta.requiresRole
      : [to.meta.requiresRole];

    if (!auth.hasSomeRole(requiredRoles as string[])) {
      return next('/unauthorized');
    }
  }

  if (to.meta.requiresGroup) {
    const requiredGroups = Array.isArray(to.meta.requiresGroup)
      ? to.meta.requiresGroup
      : [to.meta.requiresGroup];

    if (!auth.hasSomeGroup(requiredGroups as string[])) {
      return next('/unauthorized');
    }
  }

  return next();
});

export default router;
